import { AT_LEAST_ONE_ENTRY_GROUPS } from './hooks';
import { requiredFieldsMap } from 'pages/qa-spec/hooks/useGetQaSpecRequiredFields';
import { QAS_REQUIRED_FIELD_HIDDEN_FIELDS_MAPS } from 'pages/qas-require-field/constants';

const QAS_GROUP_PATH = {
  root: 'qaSpecification',
  get Header() {
    return this.root;
  },
  get 'Product Specification'() {
    return `${this.root}.qaSpecProductSpecification`;
  },
  get Components() {
    return `${this.root}.bpComponents`;
  },
  get 'Date Coding'() {
    return this['Product Specification'];
  },
  get Statement() {
    return this['Product Specification'];
  },
  get Locations() {
    return this['Product Specification'];
  },
  get 'Shelf life'() {
    return this['Product Specification'];
  },
  get 'Dietary Certifications'() {
    return this['Product Specification'];
  },
  get 'Case Temperatures'() {
    return this['Product Specification'];
  },
  get 'Polyfluoroalkyl Substances (PFAS)'() {
    return this['Product Specification'];
  },
  // get 'Organoleptic Characteristics'() {
  //   return `${this['Product Specification']}.qaSpecProductSpecsOrganolepticCharacteristics`;
  // },
  // get ''() {
  //   return `${this['Product Specification']}.qaSpecProductSpecsOrganolepticCharacteristics`;
  // },
  get 'Fresh - Seafood'() {
    return `${this.root}.qaSpecFreshSeafood`;
  },
  get Ingredients() {
    return `${this.root}.qaSpecIngredients`;
  },
  get Allergens() {
    return `${this.root}.qaSpecAllergens`;
  },
  get Formula() {
    return `${this.root}.qaSpecFormula`;
  },
  get Claims() {
    return `${this.root}.qaSpecClaims`;
  },
  get Labeling() {
    return `${this.root}.qaSpecPackaging`;
  },
  get 'Active Ingredients Detail'() {
    return `${this.root}.factsPanel.drugFactsLabel.activeIngredients`;
  },
  get 'Inactive Ingredients'() {
    return `${this.root}.factsPanel.drugFactsLabel`;
  },
  get 'Calories Content'() {
    return `${this.root}.factsPanel.petNutritionLabel`;
  },
};

export const filterRequiredFieldsGroupData = ({
  groupsData,
  requiredFields,
  productType,
}) => {
  if (!groupsData) return [];
  if (!requiredFields) return [];

  return groupsData.reduce((accumulator, currentGroupData) => {
    const isAtLeastOneEntry = AT_LEAST_ONE_ENTRY_GROUPS.includes(
      currentGroupData.groupName
    );

    const fieldsData = filterRequiredFieldsOfGroup({
      requiredFields,
      fields: currentGroupData.fields,
      parentPath: QAS_GROUP_PATH[currentGroupData.groupName],
      productType,
    });

    const childGroupData =
      currentGroupData.childGroups?.length > 0
        ? filterRequiredFieldsGroupData({
            requiredFields,
            groupsData: currentGroupData.childGroups,
            productType,
          })
        : [];

    const hasContent = fieldsData.length || childGroupData.length;

    //* if group does not have any field or child group, do not add to list
    return hasContent
      ? [
          ...accumulator,
          {
            ...currentGroupData,
            tooltip: isAtLeastOneEntry ? 'At least one entry' : null,
            fields: fieldsData,
            childGroups: childGroupData,
          },
        ]
      : accumulator;
  }, []);
};

const genValidatePath = ({ fieldFullPath, parentPath }) => {
  if (!parentPath) return;
  if (!fieldFullPath) return;

  const fieldFullPathArray = fieldFullPath.split('.');
  const fieldName = fieldFullPathArray[fieldFullPathArray.length - 1];
  const validatePath = `${parentPath}.${fieldName}`;

  return validatePath;
};

const filterRequiredFieldsOfGroup = ({
  requiredFields,
  fields,
  parentPath,
  productType,
}) => {
  if (!fields) return [];

  const filteredFields = fields.reduce((accumulator, currentFieldItem) => {
    const fieldFullPath = currentFieldItem.fieldFullPath;
    const hardCodeFieldFullPath = requiredFieldsMap[fieldFullPath];
    const standardFieldFullPath = hardCodeFieldFullPath
      ? hardCodeFieldFullPath
      : fieldFullPath;

    const hiddenFields = QAS_REQUIRED_FIELD_HIDDEN_FIELDS_MAPS[productType];
    const isVisible = !hiddenFields?.includes(fieldFullPath);

    const isRequired = requiredFields?.includes(
      standardFieldFullPath?.toLowerCase()
    );

    const validatePath = hardCodeFieldFullPath
      ? hardCodeFieldFullPath
      : genValidatePath({ fieldFullPath, parentPath });

    // console.log('standardFieldFullPath: ', isRequired, standardFieldFullPath);

    if (isRequired && isVisible) {
      return [
        ...accumulator,
        {
          ...currentFieldItem,
          fieldFullPath: standardFieldFullPath,
          validatePath,
        },
      ];
    }

    return accumulator;
  }, []);

  return filteredFields;
};

export const getGroupRequiredFields = ({ groupRequiredFields, groupName }) => {
  return groupRequiredFields.find((groupItem) => {
    return groupItem.groupName === groupName;
  });
};
